import { Exclude, Expose, Type } from 'class-transformer';
import { UserApiModel } from './api-model/user/user.api.model';

@Exclude()
export class AuthStateModel {
  public token: string;

  public refreshToken: string;

  public user: UserApiModel;
}
